// About page content and strings
export const ABOUT_CONTENT = {
  hero: {
    title: 'About HSP',
    subtitle: "We're more than just a home services company. We're your trusted partner in maintaining the place you call home, with a commitment to excellence and customer satisfaction."
  },
  
  stats: [
    { number: '2,500+', label: 'Happy Customers' },
    { number: '15,000+', label: 'Services Completed' },
    { number: '4.9/5', label: 'Average Rating' },
    { number: '5+', label: 'Years Experience' }
  ],
  
  story: {
    title: 'Our Story',
    paragraphs: [
      'We treat your home, like our home.', 'HammerSawPaint (HSP) was founded in 2022 to make home maintenance affordable, effortless, and preventative. We began as DIY homeowner workshops, but quickly realized most people lacked the time, tools, and energy to keep up with regular upkeep. So we shifted our mission: to deliver reliable subscription home services that save homeowners money and stress.',
      'Our founders, Curt and Mohamed, saw firsthand how preventative maintenance reduces repair costs by over 50%. They knew other homeowners, landlords, and busy professionals faced the same challenge: reacting to costly breakdowns instead of investing in small, consistent upkeep.',
      'Today, HSP provides recurring home maintenance plans designed to protect your home, lower long-term repair costs, and free up your weekends. Customers choose us because of our reliability, transparency, and care. Every technician is vetted, trained, and committed to treating your home like their own.',
'With HSP, you don’t just get a service—you get a partner who keeps your home in top shape, season after season.'
    ],
    founderCard: {
      title: 'Founded by Curt & Mohamed',
      subtitle: 'Co-Founders'
    }
  },
  
  customers: {
    title: 'Customers We Service',
    subtitle: 'We understand that different homeowners have unique needs. Our flexible service plans are designed to help everyone maintain their homes with ease.',
    items: [
      {
        title: 'Senior/Aging in Place Homeowners',
        description: 'Stay in the home you love without the physical strain of maintenance. We provide reliable, consistent service so you never have to climb ladders, pull weeds, or worry about outdoor chores again.'
      },
      {
        title: 'Busy Homeowners & Working Professionals',
        description: 'Time is your most valuable asset. We handle all your exterior maintenance so you can focus on what matters most—your career, family, and free time. No more sacrificing weekends to yard work.'
      },
      {
        title: 'Property Investors & Landlords',
        description: 'Protect your investment with preventative maintenance that can reduce repair costs by 30-50% according to industry studies. Our subscription service keeps your properties in top condition, maximizing value and tenant satisfaction.'
      }
    ]
  },
  
  team: {
    title: 'Meet Our Team',
    subtitle: 'Meet the founders building technology-driven home maintenance for Bay Area homeowners.',
    members: [
      {
        name: 'Curt Pope',
        role: 'CEO & Founder',
        bio: 'Engineer–designer and Ex-Google leader who has shipped enterprise-scale mobile/AI systems (Monks(MediaMonks),PayPal, NBA, Verizon, Marvel). Startup founder with multiple exits. At HammerSawPaint, Curt drives product, design, and platform—AI quoting, routing, and provider QA—to make subscription home maintenance simple, reliable, and profitable.',
        avatar: 'CP',
        specialties: ['Product Strategy', 'AI/ML Systems', 'Mobile/AI Systems', 'UX/UI Design', 'Platform Design']
      },
      {
        name: 'Mohamed Ayadi',
        role: 'CTO & Founder',
        bio: 'Mohamed Ayadi is the CTO of HammerSawPaint, bringing 10+ years of engineering leadership at Allstate, Wells Fargo, and Avail. He specializes in building scalable mobile and cloud systems that align technology with business growth. At HammerSawPaint, Mohamed drives the platform that powers seamless subscription-based home services, ensuring reliable, tech-enabled solutions for Bay Area homeowners.',
        avatar: 'MA',
        specialties: ['Engineering Leadership', 'Cloud Architecture', 'Mobile Systems']
      }
    ]
  }
};
